<template lang="pug">
.mt-4
  v-card.mb-4(v-if="false")
    v-card-text
      v-simple-table
        template(v-slot:default)
          thead
            tr
              th Name
              th Action
          tbody
            tr 
              td
                | {{ candidate.first_name }}
                | {{ candidate.last_name }}
              td 
                v-btn(
                  color="error",
                  :disabled="isNonEditable",
                  :loading="candidateDeleteLoading",
                  @click="remove"
                ) delete

  CandidateEditor(v-if="candidateEditorShown")

  v-card(v-else)
    v-card-text
      v-row
        v-col(md="9")
          div
            p
              span
                | You should provide data
                | on this page only
                | if you have a candidate.

              br

              span
                | You need to provide information
                | about your Candidate
                | to the Home Office,
                | and we made it easy for you
                | -
                | simply invite a candidate
                | (e.g. migrant worker)
                | you wish to employ,
                | and they will have their account
                | on the Nation.better platform.
                | We will guide them
                | on what they need to do
                | -
                | so no emails
                | or chasing from you.

        v-col(md="3")
          div
            v-btn(
              block,
              color="primary",
              :disabled="!isPaid || isNonEditable",
              @click="openInviteDialog"
            ) invite

            v-dialog(width="500", v-model="inviteDialog")
              v-card
                v-card-title.headline Invite candidate
                v-card-text
                  v-text-field(
                    name="email",
                    label="Email",
                    :disabled="isNonEditable",
                    v-model="candidateEmail"
                  )
                v-divider
                v-card-actions
                  v-spacer
                  v-btn(
                    text,
                    :disabled="isNonEditable",
                    @click="inviteDialog = false"
                  ) cancel
                  v-btn(
                    text,
                    color="primary",
                    :disabled="isNonEditable",
                    :loading="candidateInviteLoading",
                    @click="invite"
                  ) invite

            v-btn.mt-4(
              block,
              text,
              :disabled="!isPaid || isNonEditable",
              :loading="loading",
              @click="fillInMyself"
            ) i'll fill in by myself
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import CandidateEditor from "./helpers/CandidateEditor";

export default {
  name: "employer-case-candidate",

  components: {
    CandidateEditor,
  },

  data: () => ({
    inviteDialog: false,
    candidateEmail: "",
    candidateDeleteLoading: false,
    candidateInviteLoading: false,
    dialog: false,
    isLoader: false,
    loading: false,
  }),

  computed: {
    ...mapState("flows", {
      flows: ({ list }) => list,
    }),
    ...mapState("usercase/sponsorship", ["candidate"]),
    ...mapGetters("usercase", ["currentUsercase", "isPaid"]),
    ...mapGetters("usercase", ["isNonEditable"]),

    isShown() {
      return (
        this.currentUsercase?.case_candidate_filled_by === "candidate" &&
        this.candidate?.user_id !== 0
      );
    },

    userflow() {
      return this.flows.find(({ flow: { alias } }) => alias === "candidate");
    },

    candidateEditorShown() {
      return (
        this.currentUsercase?.case_candidate_filled_by === "candidate" ||
        this.userflow?.status === "passed"
      );
    },
  },

  methods: {
    ...mapActions("usercase/sponsorship", [
      "refreshCandidate",
      "candidateFilledByEmployer",
      "deleteCandidate",
      "inviteCandidate",
    ]),

    async remove() {
      this.candidateDeleteLoading = true;
      await this.deleteCandidate();
      this.candidateDeleteLoading = false;
    },

    async invite() {
      this.candidateInviteLoading = true;
      const data = {
        email: this.candidateEmail,
      };
      await this.inviteCandidate(data);
      this.candidateInviteLoading = false;
      this.inviteDialog = false;
    },

    openInviteDialog() {
      if (!this.isPaid) {
        this.$store.commit("setPayDialog", true);
      } else {
        this.inviteDialog = true;
      }
    },

    async fillInMyself() {
      if (!this.isPaid) {
        this.$store.commit("setPayDialog", true);
      } else {
        this.loading = true;
        await this.candidateFilledByEmployer();
        this.loading = false;
      }
    },
  },

  mounted() {
    this.refreshCandidate();
  },
};
</script>